import {useTheme} from '@mui/material/styles'
import Markdown, {MarkdownToJSX} from 'markdown-to-jsx'
import React from 'react'
import './markdownTextStyleOverrides.css'

import {dataTestId as spreadDataTestId} from '../../../../common/utils/testingUtils'

interface MarkdownTextProps {
  children: string
  options?: MarkdownToJSX.Options
  ['data-test-id']?: string
}

export const MarkdownText: React.FC<MarkdownTextProps> = ({
  children,
  options,
  'data-test-id': dataTestId
}) => {
  const theme = useTheme()
  const text = String(children ?? '')

  const defaultOptions: MarkdownToJSX.Options = {
    overrides: {
      a: {
        props: {
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      },
      ul: {
        props: {
          style: {
            listStyleType: 'disc',
            paddingLeft: '1.5em'
          }
        }
      },
      ol: {
        props: {
          style: {
            listStyleType: 'decimal',
            paddingLeft: '1.5em'
          }
        }
      },
      li: {
        props: {
          style: {
            display: 'list-item'
          }
        }
      },
      blockquote: {
        props: {
          style: {
            borderLeft: `4px solid ${theme.palette.divider}`,
            paddingLeft: '0.5em',
            margin: '0.5em 0'
          }
        }
      }
    }
  }

  return (
    <div className="markdown-text" {...spreadDataTestId(dataTestId ?? 'markdown_text')}>
      <Markdown options={{...defaultOptions, ...options}}>{`\n\n${text}\n\n`}</Markdown>
    </div>
  )
}
